var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarAccident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.229 127.561C93.6843 145.892 70.7446 162.172 47.4985 138.606C35.2734 126.213 14.3182 93.5732 13.8171 66.7601C7.98739 43.8847 30.3299 27.758 41.2357 17.096C64.2388 -5.39252 93.2279 17.1276 116.474 40.6934C139.72 64.2592 143.232 105.072 120.229 127.561Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 66.0623C80.3645 61.1661 81.3851 51.3004 82.5515 51.0066C84.0094 50.6394 87.6544 65.6951 88.7479 65.3279C89.8414 64.9606 100.047 53.9443 101.505 53.9443C102.672 53.9443 101.505 63.9814 100.776 69",
    stroke: "#EF533F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0726 124.041C68.9295 128.161 68.9009 136.312 69.9314 135.959C71.2195 135.518 84.5308 124.924 85.3896 124.041C86.2483 123.158 90.9716 136.842 91.8303 135.959C92.5173 135.253 96.6967 130.368 98.7005 128.014L106 135.959",
    stroke: "#EF533F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.669 82.3789C120.958 85.2458 124.825 91.112 129.981 91.6413C136.426 92.3029 146.922 91.6413 149.5 91.6413",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4984 111.643C95.3323 109.706 91 103.767 91 95.5038C91 87.2405 96.1987 85.1746 98.7981 85.1745C100.748 84.9594 105.426 83.7543 108.546 80.6555C112.445 76.7821 125.441 68.3897 138.438 69.0352C141.751 69.1998 144.896 69.1546 148 69.167",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.619 106.776C109.815 104.014 115.765 99.3169 121.993 102.632C129.779 106.776 130.378 115.064 127.983 119.208C125.587 123.352 116.004 126.905 110.614 122.168C106.302 118.38 106.022 112.696 106.421 110.328",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 112.889C140.807 112.889 143.344 112.889 138.429 112.889",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3397 97.3671C40.8248 97.6594 37.4391 106.119 36.8107 110.312L37.7025 114.726C38.7146 117.429 42.4381 123.174 49.2348 124.525C57.7307 126.215 65.6068 116.764 65.6101 111.014C65.6133 105.264 59.9833 97.0018 49.3397 97.3671Z",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 32.5C10.0563 32.5 15.1342 30.9926 20.5426 35.0489C25.951 39.1053 23.2468 51.2741 28.6552 51.2741C34.0636 51.2741 52.4834 49.922 55.1876 53.9783C57.8918 58.0346 72.765 78.3162 76.8213 83.7247C80.8776 89.1331 78.1734 105.358 74.1171 106.71",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9377 63.6384C47.2265 63.6384 37.6553 63.6384 37.0602 63.6384C36.3163 63.6384 34.0846 73.3392 39.2918 74.2211C43.4575 74.9266 53.4255 74.5151 57.8888 74.2211",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9727 46.0833L29.3615 100.944",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 110C12.5172 108.859 22.8333 108.487 27 110",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H158V158H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarAccident);
export default __webpack_public_path__ + "static/media/car_accident.19ccfbc71fa5439470b1dee8dcf47de8.svg";
export { ForwardRef as ReactComponent };